module.exports = __webpack_public_path__ + "img/ce.10a979bc.png";